{
  "maximum": "Maksimum",
  "minimum": "Minimum"
}
